import { Component, input } from '@angular/core';

@Component({
    selector: 'cor-splash',
    template: `
        <div
            class="tw:fixed tw:surface-ground tw:w-screen tw:h-screen tw:flex tw:items-center tw:justify-center"
            role="status"
            [attr.aria-label]="label()"
        >
            <img
                src="assets/images/splash-screen-loader.gif"
                [alt]="label()"
                class="tw:"
                width="120"
                height="120"
            />
        </div>
    `,
})
export class SplashComponent {
    /** Accessible label for the loading indicator (e.g. for screen readers). */
    readonly label = input('Loading application');
}
